import { Pipe, PipeTransform, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import { SignError, SignToken } from '../sign.model';

@Pipe({
    name: 'apSignError'
})
export class ApSignErrorPipe implements PipeTransform {
    private readonly contentService = inject(ApContentService);

    public transform(error: SignError, selectedToken: SignToken): string {
        const key = `sign.${selectedToken}.${error.key}`;
        const value = this.contentService.get(key);
        if (key !== value) {
            return value;
        }
        return this.contentService.get(`sign.${error.key}`);
    }
}
